module.exports = __webpack_public_path__ + "top_bloggeri_header.335b53446235e4f3b02b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top_bloggeri_header.jpg
// module id = 663
// module chunks = 2